import {FormModel} from "./form.model.abstract";
import {ValidatorFn} from "@angular/forms";

/**
 * A slider for setting two percentage values at one.
 * @inheritDoc
 */
export class FormModelPercent extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'percent';

  /**
   * @inheritDoc
   * @param id
   * @param fieldIds The ids of the subfields.
   * @param validators
   * @param values List of initial values for the subfields.
   * @param info
   */
  constructor(id: string, fieldIds: string[], validators: ValidatorFn[] = [], values: number[] = [], info: boolean = true) {
    super(id, validators, null, null, info);

    this.fieldData["ids"] = fieldIds;
    this.fieldData["values"] = values;
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelPercent {
    // @ts-ignore
    return new this.constructor(this.id, this.fieldData["ids"], this.validators, this.fieldData["values"], this.info);
  }

  /**
   * @inheritDoc
   */
  getIds(): string[] {
    return this.fieldData["ids"];
  }
}
